<template>
    <div class="loginContent">
        <el-form :rules="rules" ref="ruleForm" :model="ruleForm">
            <el-form-item prop="tel">
                <span class="iconfont iconicon_dl_shouji"></span>
                <el-input v-model="ruleForm.tel" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="code">
                <span class="iconfont iconicon_dl_yanzm"></span>
                <el-input v-model="ruleForm.code" placeholder="请输入验证码" autocomplete="new-password"></el-input>
                <span class="sendCode" v-show="time === 0" @click="sendCode">发送验证码</span>
                <span class="sendCode" v-show="time > 0">{{time}}</span>
            </el-form-item>
        </el-form>
        <!-- <NoCaptcha :id="6" ref="NoCaptcha" style="width:100%;" @result="(r) => nocaptchaParams = r" /> -->
        <el-button type="primary" :disabled="!canLogin" @click="changeParentTitle('输入密码', 'registerPwd')" :loading='nextSteping'>下一步</el-button>
    </div>
</template>
<script>
import { telType } from './verification'
// import NoCaptcha from './NoCaptcha'
import { getAuthCode, nextStep } from '../../axios/user'
export default {
    components: {
        // NoCaptcha
    },
    data () {
        var varifacationTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'))
            } else if (!telType.test(this.ruleForm.tel)) {
                callback(new Error('手机号码格式错误!'))
            } else {
                callback()
            }
        }
        return {
            ruleForm: {
                tel: '',
                code: ''
            },
            nextSteping:false,
            time: 0,
            // nocaptchaParams: null,
            reduceTime: null,
            rules: {
                tel: [
                    { validator: varifacationTel, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { min: 4, max: 4, message: '验证码格式不正确', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        changeParentTitle (val, type) {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.nextSteping = true;
                      let nextStepData = {
                     phone:this.ruleForm.tel, 
                     authCode:this.ruleForm.code,
                     type:1, 
                    //  ...this.nocaptchaParams,
                    //  afsToken:this.nocaptchaParams.token,
                     }
                    nextStep(nextStepData).then((data) => {
                        window.localStorage.setItem('token', data.data.data)
                        window.localStorage.setItem('tel', this.ruleForm.tel)
                        window.localStorage.setItem('code', this.ruleForm.code)
                        if (data.data.success) {
                            this.$emit('changeLoginType', val, type)
                        } 
                    }).finally(() => {
                        this.nextSteping = false;
                    })
                } else {
                    return false
                }
            })
        },
        sendCode () {
            getAuthCode(this.ruleForm.tel, 1).then(({data}) => {
                if (data.success) {
                    this.$message({
                        message: '发送成功',
                        type: 'success'
                    })
                    this.time = 60
                    this.reduceTime = setInterval(() => {
                        this.time -= 1
                        if (this.time === 0) {
                            clearInterval(this.reduceTime)
                        }
                    }, 1000)
                }
            }).catch(() => {
            })
        }
    },
    computed: {
        canLogin () {
            return (!!(telType.test(this.ruleForm.tel)) && !!(this.ruleForm.code.length === 4))
        }
    },
    beforeDestroy () {
        clearInterval(this.reduceTime)
    }
}
</script>
<style scoped lang="scss">
.loginContent {
    padding-top: 30px;
    .el-form-item {
        margin-bottom: 20px;

        .iconfont {
            position: absolute;
            left: 12px;
            top: 14px;
            font-size: 18px;
            line-height: 18px;
            color: #ccc;
            z-index: 1;
        }

        .sendCode:hover {
            color: #0263BB;
        }

        .sendCode {
            position: absolute;
            top: 13px;
            right: 0;
            width: 98px;
            height: 20px;
            display: flex;
            justify-content: center;
            line-height: 20px;
            font-size: 14px;
            color: #999999;
            border-left: 1px solid #E6E6E6;
            cursor: pointer;
        }
    }

    button {
        width: 100%;
        height: 46px;
        margin-top: 57px;
        background: #0263BB;
        border-color: #0263BB;
    }
}
</style>
